import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Lupe", -1),
    _createElementVNode("path", {
      d: "M116 28c-26.47 0-48 21.53-48 48s21.53 48 48 48 48-21.53 48-48-21.53-48-48-48",
      style: {"fill":"none"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M172 76c0-30.88-25.12-56-56-56S60 45.12 60 76c0 14 5.18 26.81 13.71 36.64l-52.53 52.53 5.66 5.66 52.53-52.53c9.83 8.52 22.64 13.7 36.64 13.7 30.88 0 56-25.12 56-56Zm-56 48c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48",
      style: {"fill":"#2d2d2d"}
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search"}) } }